import React from 'react';
const CarFeedback = () => <div style={{padding:32}}>Үнэлгээ, санал хүсэлт (stub)</div>;
export default CarFeedback;
